export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "Interior Designer",
    company: "Modern Spaces Studio",
    content: "The river table we commissioned for our client is absolutely breathtaking. The quality and attention to detail exceeded our expectations. It's become the centerpiece of their dining room.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
    location: "San Francisco, CA",
    productPurchased: "Azure River Dining Table"
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Restaurant Owner",
    company: "The Artisan Kitchen",
    content: "Our custom bar top has become the highlight of our establishment. Customers are constantly amazed by the craftsmanship, and it's incredibly durable for commercial use.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    location: "New York, NY",
    productPurchased: "Crystal Clear Bar Top"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    role: "Homeowner",
    company: null,
    content: "The coffee table is a true work of art. It's durable, beautiful, and the perfect conversation starter. The ocean wave design captures light beautifully throughout the day.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    location: "Austin, TX",
    productPurchased: "Ocean Wave Coffee Table"
  },
  {
    id: 4,
    name: "David Thompson",
    role: "Architect",
    company: "Thompson & Associates",
    content: "Working with ResinCraft Studio was exceptional. They understood our vision perfectly and delivered a custom piece that fits seamlessly into our modern office design.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    location: "Seattle, WA",
    productPurchased: "Sunset Horizon Desk"
  },
  {
    id: 5,
    name: "Jessica Park",
    role: "Art Collector",
    company: null,
    content: "The galaxy console is like having a piece of the cosmos in my home. The LED integration adds such a magical touch. Truly a masterpiece of functional art.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
    location: "Los Angeles, CA",
    productPurchased: "Midnight Galaxy Console"
  },
  {
    id: 6,
    name: "Robert Martinez",
    role: "Hotel Manager",
    company: "Luxury Suites Downtown",
    content: "We've ordered multiple pieces for our hotel lobby. Each one is unique and adds such elegance to our space. Our guests are always impressed by the quality.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=150&h=150&fit=crop&crop=face",
    location: "Miami, FL",
    productPurchased: "Multiple Custom Pieces"
  }
];

export const stats = [
  {
    number: "500+",
    label: "Pieces Crafted",
    description: "Each one unique and handmade"
  },
  {
    number: "98%",
    label: "Client Satisfaction",
    description: "Based on customer reviews"
  },
  {
    number: "6",
    label: "Years Experience",
    description: "Perfecting our craft"
  },
  {
    number: "15",
    label: "Master Craftsmen",
    description: "Skilled artisans on our team"
  }
];

export const getTestimonialsByRating = (minRating = 4) => {
  return testimonials.filter(testimonial => testimonial.rating >= minRating);
};

export const getRandomTestimonials = (count = 3) => {
  const shuffled = [...testimonials].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};